<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true">
      {{ $t('discounts.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('discounts.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('discounts.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('generic.id') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'identifier'"
                name="id"
                v-validate="modelValidations.required"
                :error="getError('id')"
                v-model="formDetails.id">
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('discounts.details.description') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('description')">
                <textarea class="form-control"
                          name="description"
                          data-vv-as="'description'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.description"
                          rows="2"/>
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('discounts.details.type') }}</label>
            <div class="col form-group">
              <el-select
                class="select-primary"
                name="role"
                v-model="formDetails.type"
              >
                <el-option
                  v-for="option in availableTypes"
                  class="select-primary"
                  :value="option"
                  :label="option"
                  :key="option"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('discounts.details.sort_priority') }}</label>
            <div class="col-md-9">
              <base-input :error="getError('sort_priority')">
                <base-input
                  data-vv-as="'sort_priority'"
                  name="sort_priority"
                  v-validate="modelValidations.required"
                  :error="getError('sort_priority')"
                  v-model.number="formDetails.sort_priority"
                  type="number">
                </base-input>
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('discounts.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import discount_types from './discount_types';

export default {
  name: 'new-discount-btn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        id: '',
        description: '',
        sort_priority: 1,
        type: discount_types[0]
      },
      modelValidations: {
        required: {
          required: true
        },
      },
      availableTypes: discount_types
    }
  },

  computed: {
    ...mapState({
      updating: state => state.discount.updating,
      error: state => state.discount.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['CreateDiscount', 'LoadDiscounts']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let payload = {
        id: this.formDetails.id,
        description: this.formDetails.description,
        sort_priority: this.formDetails.sort_priority,
        type: this.formDetails.type,
      }

      this.CreateDiscount(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.LoadDiscounts();
          this.resetForm();
          this.$notify({
            type: 'success',
            message: this.$t('discounts.create.createdNotification', payload),
            icon: 'tim-icons icon-alert-circle-exc'
          })
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        id: '',
        description: '',
        sort_priority: 1,
        type: discount_types[0]
      };

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
